import { authClient, API } from '../index'

// Enviar campaña promocional
export const sendCampaign = (campaignData) => {
  return authClient().post(`${API}/brevo/send-campaign`, campaignData)
}

// Obtener estadísticas de la lista de promociones
export const getBrevoStats = () => {
  return authClient().get(`${API}/brevo/stats`)
}

